export interface IGuideline {
  text: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  media?: any;
  is_default_guideline: boolean;
}
